$(window).on("load", () => {
  $("body").removeClass("preloader");
  let viewed = false;

  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
  }

  function animationCountring() {
    if (isScrolledIntoView($(".counterIcons__grid")) && !viewed) {
        viewed = true;
        $('.counterIcons__single-number').each(function () {
        $(this).prop('Counter',0).animate({
            Counter: $(this).text()
        }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
                $(this).text(Math.ceil(now));
            }
        });
      });
    }
  }

  $(".projectOffice__tabs-single").click(function (e) {
    e.preventDefault();
    $(".projectOffice__tabs-single").removeClass(
      "projectOffice__tabs--single-active"
    );
    $(this).addClass("projectOffice__tabs--single-active");
    $(".projectOffice__single").addClass("projectOffice__single--hidden");
    $(`.projectOffice__single[data-tab="${$(this).data("tab")}"]`).removeClass(
      "projectOffice__single--hidden"
    );
  });

  $(".realization__tabs-single").click(function (e) {
    e.preventDefault();
    $(".realization__tabs-single").removeClass(
      "realization__tabs--active-single"
    );
    $(this).addClass("realization__tabs--active-single");
    $(".realizationList__grid").addClass("realizationList__grid--hidden");
    $(`.realizationList__grid[data-tab="${$(this).data("tab")}"]`).removeClass(
      "realizationList__grid--hidden"
    );
  });

  // Check if is clicked
  $(".nav__item--parent.nav__item--current").addClass("nav__item--expanded");
  $(".nav__item--parent.nav__item--current .nav__sub").show();
  $(".nav__item--parent.nav__item--parent--current").addClass(
    "nav__item--expanded"
  );
  $(".nav__item--parent.nav__item--parent--current .nav__sub").show();

  $(".nav__arrow").click(function () {
    const parent = $(this).parent();
    const currentSubMenu = $(this).next();

    $(".nav__item--parent").not(parent).removeClass("nav__item--expanded");
    $(".nav__sub").not(currentSubMenu).slideUp();

    if (!parent.hasClass("nav__item--expanded")) {
      parent.addClass("nav__item--expanded");
      currentSubMenu.slideDown();
    } else {
      parent.removeClass("nav__item--expanded");
      currentSubMenu.slideUp();
    }
  });

  $(".modalTrigger").click(function (e) {
    e.preventDefault();
    $(".modal").removeClass("modal--active");
    const modalId = $(this).data("modal");
    $(`.modal[data-modal="${modalId}"]`).addClass("modal--active");
  });

  $(".modal__top-exit").click(function () {
    const modalId = $(this).data("modal");
    $(`.modal[data-modal="${modalId}"]`).removeClass("modal--active");
  });

  $(window).scroll(function () {
    animationCountring()
    if ($(this).scrollTop() > 300) {
      $("#gotToTop").fadeIn();
    } else {
      $("#gotToTop").fadeOut();
    }
  });

  if ($(".slider").length > 0) {
    $(".slider").each(function () {
      $(this).slick({
        dots: true,
        arrows: true,
        // infinite: true,
        cssEase: "linear",
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: false,
      });
    });
  }

  $(".productPage__carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".productPage__nav",
  });

  $(".productPage__nav").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: ".productPage__carousel",
    dots: false,
    centerMode: false,
    arrows: true,
    focusOnSelect: true,
    vertical: true,
    responsive: [
      {
        breakpoint: 1700,
        settings: {
          vertical: true,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          vertical: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          vertical: false,
        },
      },
    ],
  });

  if ($(".blogBigger__single").length !== 0) {
    $(".blogBigger__single").each(function () {
      $("<a/>")
        .addClass("blogBigger__panels-single")
        .attr("href", `#${$(this).attr("id")}`)
        .appendTo(".blogBigger__panels");
    });

    $(".blogBigger__panels-single:first-child").addClass(
      "blogBigger__panels--active-single"
    );

    const target = $(".blogBigger__panels");
    $(window).scroll(function () {
      var scrollDistance = $(window).scrollTop();

      if (
        $(".blogBigger").height() -
          $(".blogBigger__panels").height() -
          $(".blogBigger__panels").position().top <
        scrollDistance
      ) {
        if (!$(".blogBigger__panels").hasClass("blogBigger__panels--hidden")) {
          $(".blogBigger__panels").addClass("blogBigger__panels--hidden");
        }
      } else {
        if ($(".blogBigger__panels").hasClass("blogBigger__panels--hidden")) {
          $(".blogBigger__panels").removeClass("blogBigger__panels--hidden");
        }
      }

      // if (
      //   scrollDistance >
      //   $(".blogBigger__single:last-child").offset().top +
      //     $(".blogBigger__single").height() / 2 -
      //     $(".blogBigger__panels").height() / 2
      // ) {
      //   $(".blogBigger__panels").addClass("blogBigger__panels--dark");
      // } else {
      //   $(".blogBigger__panels").removeClass("blogBigger__panels--dark");
      // }

      $(".blogBigger__single").each(function (i) {
        if ($(this).position().top < scrollDistance) {
          $(".blogBigger__panels--active-single").removeClass(
            "blogBigger__panels--active-single"
          );
          $(".blogBigger__panels-single")
            .eq(i)
            .addClass("blogBigger__panels--active-single");
        }
      });
    });

    $(".blogBigger__panels-single").bind("click", function (e) {
      e.preventDefault();

      var target = $(this).attr("href");
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $(target).offset().top,
          },
          600,
          function () {
            location.hash = target;
          }
        );

      return false;
    });
  }

  if ($(".variations__value").length !== 0) {
    $(".variations__value select").each(function (e) {
      const data = $(this).attr("id");
      $(this).change(function () {
        $(`.productPage__attributes-value[data-attribute="${data}"]`).text(
          this.value
        );
      });
    });
  }

  if ($("form.variations_form").length !== 0) {
    const form = $("form.variations_form");
    let variable_product_price = "";
    let currency = "";
    setInterval(function () {
      if ($(".single_variation_wrap span.price span.amount").length !== 0) {
        if (
          $(".single_variation_wrap span.price span.amount").text() !==
          variable_product_price
        ) {
          variable_product_price = $(
            ".single_variation_wrap span.price span.amount"
          )
            .text()
            .replace(/[^0-9\.]/g, "");
          currency = $(".single_variation_wrap span.price span.amount")
            .text()
            .replace(/[\d.]/g, "");
          $(".productPrice__price-value").text(
            variable_product_price + currency
          );
          $(".productPrice__netto-value").text(
            (variable_product_price / 1.23).toFixed(2) + currency
          );
          $(".productPrice").show();
        }
      }
    }, 500);
  }

  $("#gotToTop").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });

  if ($(".cookies").length > 0) {
    $(".cookies__exit").click((e) => {
      e.preventDefault();
      $(".cookies").fadeOut();
    });

    $(".cookies__accept").click(function (e) {
      e.preventDefault();
      $(".cookies").fadeOut();
      $.ajax({
        url: "/cookieset.php",
        type: "post",
        data: {
          cookie_name: "cookies-accept",
          time: 48,
        },
        success: function (response) {},
      });
    });
  }

  $(".faq__name").click(function () {
    const single = $(this).parent();
    const data = single.data("faq");
    $(`.faq__single[data-faq="${data}"]`)
      .not(single)
      .removeClass("faq__single--active");
    $(`.faq__single[data-faq="${data}"]`)
      .not(single)
      .find(".faq__content")
      .slideUp();
    if (single.hasClass("faq__single--active")) {
      single.removeClass("faq__single--active");
      single.find(".faq__content").slideUp();
    } else {
      single.addClass("faq__single--active");
      single.find(".faq__content").slideDown();
    }
  });

  const lightBox = new SmartPhoto(".realizationList__single-url", {
    resizeStyle: "fit",
  });

  AOS.init({
    mirror: false,
    offset: 250,
    duration: 400,
    anchorPlacement: "top-bottom",
  });

  // setTimeout(()=>{
  //   AOS.refresh()
  // },200)
});
